/*
 * STEPMASTERS a11y: kleine Barrierefreiheits-Helfer (Theme 2.35, Umsetzungsplan Teil A).
 * Eigene Datei statt Patch in Horizon-Dateien, damit Theme-Updates nichts ueberschreiben.
 */
(function () {
  'use strict';

  var root = document.documentElement;

  /* A-04: Cookie-Banner von Shopify verdeckt fokussierte Elemente (WCAG 2.4.11, Technik C43).
   * Solange er sichtbar ist, bekommt der Scrollbereich unten so viel Innenabstand wie der Banner hoch ist. */
  function updateBannerPadding() {
    var banner = document.getElementById('shopify-pc__banner');
    var wrapper = document.querySelector('.page-wrapper');
    var visible = !!banner && banner.getClientRects().length > 0 && getComputedStyle(banner).display !== 'none';
    var value = visible ? Math.ceil(banner.getBoundingClientRect().height) + 16 + 'px' : '';
    root.style.scrollPaddingBottom = value;
    if (wrapper) wrapper.style.scrollPaddingBottom = value;
    /* Theme 2.44 (Audit 15.10.2026, a11y E1): Am Seitenende hilft scroll-padding nicht mehr, weil nichts mehr zu
     * scrollen ist. Der Footer (sections/sm-footer.liquid) haengt deshalb unten denselben Platz an. */
    if (value) root.style.setProperty('--sm-cookie-banner-platz', value);
    else root.style.removeProperty('--sm-cookie-banner-platz');
  }

  var observedBanner = null;
  var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(updateBannerPadding) : null;

  /* Shop-Abschluss 2026-10-13 (technik-06): Gemessen wird nur noch, wenn ein Banner neu auftaucht oder
   * verschwindet, und dann gebuendelt im naechsten Frame. Groessenaenderungen meldet der ResizeObserver,
   * Aenderungen an style/class/hidden der MutationObserver am Banner selbst. Der Beobachter am <body>
   * bleibt, weil "Cookie-Einstellungen" den Banner neu einfuegen kann. */
  var paddingFrame = 0;
  function schedulePadding() {
    if (paddingFrame) return;
    paddingFrame = requestAnimationFrame(function () {
      paddingFrame = 0;
      updateBannerPadding();
    });
  }

  function watchBanner() {
    var banner = document.getElementById('shopify-pc__banner');
    if (banner && banner !== observedBanner) {
      observedBanner = banner;
      if (resizeObserver) resizeObserver.observe(banner);
      new MutationObserver(schedulePadding).observe(banner, {
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      });
      schedulePadding();
    } else if (!banner && observedBanner) {
      // Banner entfernt: Abstand zuruecksetzen
      if (resizeObserver) resizeObserver.unobserve(observedBanner);
      observedBanner = null;
      schedulePadding();
    }
  }

  // Shopify fuegt den Banner nachtraeglich als erstes Kind von <body> ein
  new MutationObserver(watchBanner).observe(document.body, { childList: true });
  watchBanner();

  /* A-13: Menue-Drawer am Handy. Nach "Schliessen" oder Escape von einem Link landet der Fokus sonst
   * auf <body>. toggle blubbert nicht, deshalb Capture auf document. */
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (details.id !== 'Details-menu-drawer-container' || details.open) return;
      var active = document.activeElement;
      if (active && active !== document.body && !details.contains(active)) return;
      var summary = details.querySelector('summary');
      if (!summary) return;
      requestAnimationFrame(function () {
        summary.focus({ preventScroll: true });
      });
    },
    true
  );

  /* Theme 2.39 (Shoptest #35): Unterseiten im Menue-Drawer (Region- und Sprachwahl, Untermenues). Nach Escape
   * oder "Zurueck zum Hauptmenue" lag der Fokus auf <body>, obwohl das Menue offen bleibt (WCAG 2.4.3/2.4.7).
   * Der Fokus geht zurueck auf den Ausloeser (<summary>), wenn er auf <body> oder in der geschlossenen
   * Unterseite liegt. Schliesst sich das ganze Menue ("Schliessen"), greift A-13 oben. */
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement) || details.open) return;
      var container = document.getElementById('Details-menu-drawer-container');
      if (!container || details === container || !container.contains(details)) return;
      var active = document.activeElement;
      if (active && active !== document.body && !details.contains(active)) return;
      var summary = details.querySelector('summary');
      if (!summary) return;
      requestAnimationFrame(function () {
        // Erst pruefen, wenn der Schritt fertig ist: Ist das ganze Menue inzwischen zu, nichts tun
        if (!container.open) return;
        var now = document.activeElement;
        if (now && now !== document.body && !details.contains(now)) return;
        summary.focus({ preventScroll: true });
      });
    },
    true
  );

  /* A-22: Pflicht-Zustimmung im Warenkorb mit dauerhafter Fehlermeldung statt nur der Browser-Blase.
   * Delegiert, weil der Warenkorb per morph neu gerendert wird. invalid blubbert nicht, deshalb Capture.
   * Theme 2.39 (Shoptest #4, #18, #34): preventDefault unterdrueckt die Browser-Blase, die in Browsersprache
   * und Sie-Form ueber dem Text lag. Ohne Blase setzt der Browser den Fokus nicht selbst, deshalb hier.
   * Die Meldung haengt nur bei sichtbarem Fehler per aria-describedby am Haken (ein verstecktes, direkt
   * referenziertes Element wuerde sonst immer mit vorgelesen). Ohne JavaScript greift weiter required. */
  function consentError(box) {
    var container = box.closest('.cart__ctas');
    return container ? container.querySelector('.sm-consent__error') : null;
  }

  document.addEventListener(
    'invalid',
    function (event) {
      var box = event.target;
      if (!(box instanceof HTMLInputElement) || !box.classList.contains('sm-consent__box')) return;
      event.preventDefault();
      box.setAttribute('aria-invalid', 'true');
      var error = consentError(box);
      if (error) {
        error.hidden = false;
        if (error.id) box.setAttribute('aria-describedby', error.id);
      }
      if (document.activeElement !== box) box.focus();
    },
    true
  );

  document.addEventListener('change', function (event) {
    var box = event.target;
    if (!(box instanceof HTMLInputElement) || !box.classList.contains('sm-consent__box') || !box.checked) return;
    box.removeAttribute('aria-invalid');
    box.removeAttribute('aria-describedby');
    var error = consentError(box);
    if (error) error.hidden = true;
  });

  /* Theme 2.39 (Shoptest #37): Die Warenkorb-Schublade ist ab 990 px ein nicht-modaler <dialog> (show())
   * mit Fokusfalle (assets/theme-drawer.js). Solange die Falle greift (Oeffnen per Klick oder nach dem
   * Hinzufuegen, Fokus in der Schublade), ist sie modal wie am Handy: aria-modal am Dialog, die uebrige
   * Seite inert, damit Screenreader sie nicht mitlesen. Ein Klick neben die Schublade schliesst sie (wie
   * der Hintergrund am Handy). Beim Wiederherstellen nach einem Seitenwechsel bleibt sie eine Seitenleiste
   * ohne Falle (snippets/theme-drawer.liquid) und deshalb ohne aria-modal und ohne inert. */
  var drawerInert = [];

  function cartDrawerPanel(target) {
    if (!(target instanceof HTMLElement) || target.id !== 'cart-drawer') return null;
    var panel = target.querySelector('dialog');
    return panel instanceof HTMLDialogElement ? panel : null;
  }

  function releaseDrawerInert() {
    for (var i = 0; i < drawerInert.length; i++) drawerInert[i].inert = false;
    drawerInert = [];
  }

  function makePageInert(drawer) {
    releaseDrawerInert();
    var node = drawer;
    while (node && node.parentElement && node !== document.body) {
      var parent = node.parentElement;
      for (var i = 0; i < parent.children.length; i++) {
        var sibling = parent.children[i];
        if (sibling === node || sibling.inert || /^(SCRIPT|STYLE|TEMPLATE|LINK|META)$/.test(sibling.tagName)) continue;
        sibling.inert = true;
        drawerInert.push(sibling);
      }
      node = parent;
    }
  }

  document.addEventListener('theme-drawer:open', function (event) {
    var panel = cartDrawerPanel(event.target);
    if (!panel || !panel.contains(document.activeElement)) return;
    panel.setAttribute('aria-modal', 'true');
    makePageInert(event.target);
  });

  document.addEventListener('theme-drawer:close', function (event) {
    var panel = cartDrawerPanel(event.target);
    if (!panel) return;
    panel.removeAttribute('aria-modal');
    releaseDrawerInert();
  });

  // Klick auf die inerte Seite landet auf <body> bzw. <html>: Schublade schliessen
  document.addEventListener('click', function (event) {
    if (!drawerInert.length) return;
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) {
      releaseDrawerInert();
      return;
    }
    if (event.target !== document.body && event.target !== document.documentElement) return;
    if (typeof drawer.close === 'function') drawer.close();
  });

  /* A-34: Sprachwahl im Header (snippets/sm-sprachwahl.liquid). Oeffnen, Escape, Klick ausserhalb und die
   * Fokus-Rueckgabe macht der Browser (popover). Hier nur aria-expanded am Button, Pfeiltasten/Pos1/Ende in der
   * Liste und Schliessen, wenn der Fokus die Sprachwahl verlaesst. Delegiert, weil der Theme-Editor den Header
   * neu rendert. toggle blubbert nicht, deshalb Capture. Kein preventDefault bei Escape (A-33 hoert mit). */
  function sprachwahlTeile(element) {
    var root = element.closest('.sm-sprachwahl');
    if (!root) return null;
    var button = root.querySelector('.sm-sprachwahl__button');
    var panel = root.querySelector('.sm-sprachwahl__panel');
    if (!button || !panel) return null;
    return { root: root, button: button, panel: panel };
  }

  function sprachwahlOffen(panel) {
    try {
      return panel.matches(':popover-open');
    } catch (error) {
      return panel.classList.contains(':popover-open');
    }
  }

  function sprachwahlStart() {
    document.querySelectorAll('.sm-sprachwahl__button:not([aria-expanded])').forEach(function (button) {
      var teile = sprachwahlTeile(button);
      button.setAttribute('aria-expanded', teile && sprachwahlOffen(teile.panel) ? 'true' : 'false');
    });
  }

  sprachwahlStart();
  document.addEventListener('shopify:section:load', sprachwahlStart);

  document.addEventListener(
    'toggle',
    function (event) {
      var panel = event.target;
      if (!(panel instanceof HTMLElement) || !panel.classList.contains('sm-sprachwahl__panel')) return;
      var teile = sprachwahlTeile(panel);
      if (!teile) return;
      var offen = event.newState ? event.newState === 'open' : sprachwahlOffen(panel);
      teile.button.setAttribute('aria-expanded', offen ? 'true' : 'false');
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    var key = event.key;
    if (key !== 'ArrowDown' && key !== 'ArrowUp' && key !== 'Home' && key !== 'End') return;
    var target = event.target;
    if (!(target instanceof HTMLElement)) return;
    var teile = sprachwahlTeile(target);
    if (!teile) return;
    var options = Array.prototype.slice.call(teile.panel.querySelectorAll('.sm-sprachwahl__option'));
    if (!options.length) return;

    if (target === teile.button) {
      // Pfeil auf dem Button: Liste oeffnen und auf die aktuelle Sprache springen
      if (key !== 'ArrowDown' && key !== 'ArrowUp') return;
      if (!sprachwahlOffen(teile.panel)) {
        if (typeof teile.panel.showPopover !== 'function') return;
        try {
          teile.panel.showPopover({ source: teile.button });
        } catch (error) {
          return;
        }
      }
      event.preventDefault();
      var aktuell = teile.panel.querySelector('.sm-sprachwahl__option[aria-current="true"]') || options[0];
      aktuell.focus();
      return;
    }

    var index = options.indexOf(target);
    if (index < 0) return;
    event.preventDefault();
    var next = index;
    if (key === 'Home') next = 0;
    else if (key === 'End') next = options.length - 1;
    else if (key === 'ArrowDown') next = (index + 1) % options.length;
    else next = (index - 1 + options.length) % options.length;
    options[next].focus();
  });

  document.addEventListener('focusout', function (event) {
    var target = event.target;
    var next = event.relatedTarget;
    if (!(target instanceof HTMLElement) || !(next instanceof Node)) return;
    var teile = sprachwahlTeile(target);
    if (!teile || teile.root.contains(next)) return;
    // Erst nach dem Fokuswechsel schliessen, sonst holt der Browser den Fokus zum Button zurueck
    setTimeout(function () {
      if (teile.root.contains(document.activeElement) || !sprachwahlOffen(teile.panel)) return;
      if (typeof teile.panel.hidePopover === 'function') teile.panel.hidePopover();
    }, 0);
  });

  /* Theme 2.39 (Shoptest #74, WCAG 2.1.1): Ab 990 px haben html und body overflow: hidden, gescrollt wird in
   * .page-wrapper (Horizon base.css). Direkt nach dem Laden liegt der Fokus auf <body>, dann bewegen Bild-ab,
   * Leertaste, Pfeile, Pos1 und Ende nichts. Hier scrollt das Skript in diesem Fall .page-wrapper selbst. Der
   * Fokus bleibt auf <body>: Der naechste Tab-Stopp ist weiter "Direkt zum Inhalt", Screenreader merken nichts.
   * Weiches Scrollen nur ohne "Bewegung reduzieren" (scroll-behavior aus dem CSS). */
  var SCROLL_KEYS = { PageDown: 1, PageUp: 1, ArrowDown: 1, ArrowUp: 1, Home: 1, End: 1, ' ': 1, Spacebar: 1 };

  function pageScroller() {
    var wrapper = document.querySelector('.page-wrapper');
    if (!wrapper || wrapper.scrollHeight <= wrapper.clientHeight + 1) return null;
    var overflow = getComputedStyle(wrapper).overflowY;
    if (overflow !== 'auto' && overflow !== 'scroll') return null;
    // Scrollt das Dokument selbst (unter 990 px), macht der Browser alles allein
    var doc = document.scrollingElement || document.documentElement;
    if (doc.scrollHeight > doc.clientHeight + 1 && getComputedStyle(document.documentElement).overflowY !== 'hidden') return null;
    return wrapper;
  }

  document.addEventListener('keydown', function (event) {
    if (!SCROLL_KEYS[event.key] || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
    var active = document.activeElement;
    if (active && active !== document.body && active !== document.documentElement) return;
    var wrapper = pageScroller();
    if (!wrapper) return;
    var page = Math.max(wrapper.clientHeight - 80, 40);
    var top = null;
    var delta = 0;
    switch (event.key) {
      case 'PageDown':
        delta = page;
        break;
      case 'PageUp':
        delta = -page;
        break;
      case ' ':
      case 'Spacebar':
        delta = event.shiftKey ? -page : page;
        break;
      case 'ArrowDown':
        delta = 40;
        break;
      case 'ArrowUp':
        delta = -40;
        break;
      case 'Home':
        top = 0;
        break;
      case 'End':
        top = wrapper.scrollHeight;
        break;
    }
    event.preventDefault();
    if (top !== null) wrapper.scrollTo({ top: top });
    else wrapper.scrollBy({ top: delta });
  });

  /* Theme 2.39 (Shoptest #38, #18): Kontaktformular und Newsletter mit eigenen Fehlermeldungen statt der Browser-Blase
   * (Sie-Form, Browsersprache, verschwindet nach Sekunden). Formulare mit data-sm-validate pruefen ihre Felder
   * mit data-sm-msg-missing / data-sm-msg-invalid selbst: Meldung in Du-Form am Feld (<id>-sm-error, per
   * aria-describedby verknuepft, nur solange sie sichtbar ist), aria-invalid, Sammelmeldung mit role="alert"
   * ([data-sm-form-alert], falls vorhanden) und Fokus auf das erste fehlerhafte Feld. novalidate setzt erst
   * dieses Skript: Ohne JavaScript bleibt die Pruefung des Browsers (required, type="email"). */
  function smFormsPrepare() {
    var forms = document.querySelectorAll('form[data-sm-validate]');
    for (var i = 0; i < forms.length; i++) forms[i].noValidate = true;
  }

  function smFieldMessage(field) {
    var value = field.value || '';
    if (field.required && !value.trim()) return field.getAttribute('data-sm-msg-missing') || '';
    if (value.trim() && field.validity && field.validity.typeMismatch) {
      return field.getAttribute('data-sm-msg-invalid') || field.getAttribute('data-sm-msg-missing') || '';
    }
    return '';
  }

  function smSetDescribedBy(field, id, on) {
    var ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (part) {
      return part && part !== id;
    });
    if (on) ids.unshift(id);
    if (ids.length) field.setAttribute('aria-describedby', ids.join(' '));
    else field.removeAttribute('aria-describedby');
  }

  function smShowFieldError(field, message) {
    var error = field.id ? document.getElementById(field.id + '-sm-error') : null;
    if (message) {
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('data-sm-invalid', '');
    } else if (field.hasAttribute('data-sm-invalid')) {
      // Nur eigene Markierung entfernen; eine Fehlermeldung des Servers (nach dem Absenden) bleibt
      field.removeAttribute('aria-invalid');
      field.removeAttribute('data-sm-invalid');
    }
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
    smSetDescribedBy(field, error.id, !!message);
  }

  function smFormFields(form) {
    return form.querySelectorAll('[data-sm-msg-missing], [data-sm-msg-invalid]');
  }

  smFormsPrepare();
  document.addEventListener('DOMContentLoaded', smFormsPrepare);
  document.addEventListener('shopify:section:load', smFormsPrepare);

  // Capture: vor den Formular-Skripten (z. B. hCaptcha von Shopify); bei Fehlern erreicht sie das Absenden nicht
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-sm-validate')) return;
      var fields = smFormFields(form);
      var first = null;
      for (var i = 0; i < fields.length; i++) {
        var message = smFieldMessage(fields[i]);
        smShowFieldError(fields[i], message);
        if (message && !first) first = fields[i];
      }
      var alertBox = form.querySelector('[data-sm-form-alert]');
      if (!first) {
        if (alertBox) {
          alertBox.textContent = '';
          alertBox.hidden = true;
        }
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (alertBox) {
        alertBox.textContent = form.getAttribute('data-sm-msg-summary') || '';
        alertBox.hidden = !alertBox.textContent;
      }
      if (document.activeElement !== first) first.focus();
    },
    true
  );

  // Nach einem Fehler die Meldung am Feld nachfuehren, sobald korrigiert wird
  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!(field instanceof HTMLElement) || !field.hasAttribute('data-sm-invalid')) return;
    var form = field.closest('form[data-sm-validate]');
    if (!form) return;
    smShowFieldError(field, smFieldMessage(field));
    var alertBox = form.querySelector('[data-sm-form-alert]');
    if (alertBox && !form.querySelector('[data-sm-invalid]')) {
      alertBox.textContent = '';
      alertBox.hidden = true;
    }
  });

  /* Nachbesserung 04.10.2026: Abgleich nach DOM-Aenderungen (Warenkorb-morph, Rasteransicht, Nachladen).
   * (1) Pflicht-Haken: Der Haken uebersteht das Neu-Rendern (data-skip-node-update), die Fehlermeldung kommt
   *     wieder mit hidden. Dann aria-describedby/aria-invalid entfernen, sonst wuerde die unsichtbare Meldung
   *     mit vorgelesen.
   * (2) Kartenbilder (Shoptest #49): snippets/card-gallery.liquid waehlt am Handy Bilder fuer zwei Spalten
   *     (calc(50vw - 22px)). Waehlt jemand im Dichte-Umschalter die Einzelspalte (product-grid-view
   *     'mobile-single'), gilt wieder 100vw, damit der Browser passend schaerfere Bilder nachlaedt. */
  var SM_HALF = 'calc(50vw - 22px)';

  function smGridSizes(grid) {
    var single = grid.getAttribute('product-grid-view') === 'mobile-single';
    grid.querySelectorAll('img[sizes]').forEach(function (img) {
      var sizes = img.getAttribute('sizes') || '';
      if (single && sizes.indexOf(SM_HALF) !== -1) {
        img.setAttribute('data-sm-sizes', sizes);
        img.setAttribute('sizes', sizes.split(SM_HALF).join('100vw'));
      } else if (!single && img.hasAttribute('data-sm-sizes')) {
        img.setAttribute('sizes', img.getAttribute('data-sm-sizes') || sizes);
        img.removeAttribute('data-sm-sizes');
      }
    });
  }

  var smSyncQueued = false;

  function smSync() {
    smSyncQueued = false;
    document.querySelectorAll('.sm-consent__box[aria-describedby]').forEach(function (box) {
      var error = consentError(box);
      if (!error || error.hidden) {
        box.removeAttribute('aria-describedby');
        box.removeAttribute('aria-invalid');
      }
    });
    document.querySelectorAll('[product-grid-view]').forEach(smGridSizes);
  }

  function smQueueSync() {
    if (smSyncQueued) return;
    smSyncQueued = true;
    requestAnimationFrame(smSync);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(smQueueSync).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['hidden', 'product-grid-view'],
    });
  }
  smQueueSync();
})();
